import breakpoints from './breakpoints';
var mediaQueries = {};

for (var breakpoint in breakpoints) {
  mediaQueries[breakpoint] = "@media (min-width: ".concat(breakpoints[breakpoint], ")");
}

export default mediaQueries;